module.exports = __webpack_public_path__ + "img/person-icon.bd2bc500.svg";